import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: ""
}
const _hoisted_2 = {
  key: 0,
  class: "fl ml10",
  style: {"width":"130px","margin-top":"-10px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "fl mt30" }, "分", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!

  return (_ctx.appo)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_SelectTag, {
          name: "meeting_time",
          id: "select_meeting_time",
          class: "fl fs14 roundForm",
          style: {"min-width":"130px","height":"50px"},
          options: _ctx.SelectUtil.selectMeetingTimeArr,
          defaultOption: _ctx.getDefaultOption,
          onSelectValue: _ctx.selectMeetingTime
        }, null, 8, ["options", "defaultOption", "onSelectValue"]),
        (_ctx.isCustomTime)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_MdTextfieldTag, {
                name: "カスタム時間を設定",
                style: {"height":"56px","min-width":"100px"},
                fieldStyle: `min-width:60px;font-size:20px;max-width:110px;`,
                class: "fs20 fl",
                type: `number`,
                min: 1,
                max: 720,
                value: _ctx.appo.duration,
                onInputValue: _ctx.inputCustomDuration,
                onBlur: _ctx.blurCustomDuration
              }, null, 8, ["value", "onInputValue", "onBlur"]),
              _hoisted_3
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}